export default __webpack_public_path__ + "static/media/au_flashpay_fees_backgound.a443bbea.png";